var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-12"},[(!_vm.isWorking)?_c('div',[(_vm.isConnected)?_c('button',{on:{"click":_vm.logout}},[_vm._v("Logout")]):_vm._e(),(_vm.isConnected)?_c('button',{on:{"click":_vm.getAccounts}},[_vm._v("Read Accounts")]):_c('button',{on:{"click":_vm.login}},[_vm._v("Login")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }